/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Link } from "react-router";
import { Link as MuiLink } from "@mui/material";
import React, { RefObject } from "react";
import { skipLinkStyle } from "@/src/components/SkipLink/skipLinkStyle";

export type SkipLinkProps = {
  ref: RefObject<HTMLAnchorElement | null>;
};
export default function SkipLink({ ref }: SkipLinkProps) {
  return (
    <MuiLink ref={ref} component={Link} to={"#main-content"} sx={skipLinkStyle.skipLink} id={"skip-link"}>
      Zum Hauptinhalt springen
    </MuiLink>
  );
}
